import { render } from "./InvoiceDiscountOfferPanel.vue?vue&type=template&id=1d234c91&ts=true"
import script from "./InvoiceDiscountOfferPanel.vue?vue&type=script&lang=ts"
export * from "./InvoiceDiscountOfferPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__